import SecondaryButton from "@usas/ui-web/components/buttons/SecondaryButton";
import { useAccountCreationReturnButton } from "./UseAccountCreationReturnButton";

const AccountCreationReturnButton = ({ buttonLabelPrefix = 'Return to' }) => {
  const { accountCreationReturnState, onReturnToClicked } = useAccountCreationReturnButton();

  return <SecondaryButton type={'button'} onClick={onReturnToClicked}>{`${buttonLabelPrefix} ${accountCreationReturnState.returnLabel || 'Login'}`}</SecondaryButton>
};

export default AccountCreationReturnButton;